import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createAddVoucherModel } from 'features/add-voucher';
import { createBlockVoucherModel } from 'features/block-voucher';
import { createDeleteVoucherModel } from 'features/delete-voucher';
import { createEditVoucherModel } from 'features/edit-voucher';
import { createUnblockVoucherModel } from 'features/unblock-voucher';
import { accountTreeModel } from 'entities/account';
import { createVoucherRegistryModel } from 'entities/voucher';

const addVoucherModel = createAddVoucherModel({
	$currencies: accountTreeModel.$currencies,
});

const editVoucherModel = createEditVoucherModel();

const blockVoucherModel = createBlockVoucherModel();

const unblockVoucherModel = createUnblockVoucherModel();

const deleteVoucherModel = createDeleteVoucherModel();

const voucherRegistryModel = createVoucherRegistryModel({
	$currencies: accountTreeModel.$currencies,
	onDelete: [deleteVoucherModel.mutation.finished.success],
	onUpdate: [
		addVoucherModel.addVoucherMutation.finished.success,
		editVoucherModel.editVoucherMutation.finished.success,
		blockVoucherModel.mutation.finished.success,
		unblockVoucherModel.mutation.finished.success,
	],
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: voucherRegistryModel.model.filters.accountIds.setValue,
});

chain(voucherRegistryModel.model.clearFilters, accountTreeModel.clearSelectedNodes);

export const vouchersPageModel = {
	voucherRegistryModel,
	addVoucherModel,
	editVoucherModel,
	blockVoucherModel,
	unblockVoucherModel,
	deleteVoucherModel,
};
